export enum EInterventionStatus {
  AwaitingQuote = 'awaiting_quote',
  AwaitingVisitDate = 'awaiting_visit_date',
  AwaitingWorkDates = 'awaiting_work_dates',
  Lost = 'lost',
  NoCost = 'no_cost',
  QualitySurvey = 'quality_survey',
  QuoteReceived = 'quote_received',
  Success = 'success',
  Trashed = 'trashed',
  VisitPlanned = 'visit_planned',
  WorkOngoing = 'work_ongoing',
  WorkPlanned = 'work_planned',
}
